import { Commute, CommuteWithMetadata } from '../types';

export const processCommute = (commute: Commute): CommuteWithMetadata => {
  const hasPoints = Array.isArray(commute.gps_points) && commute.gps_points.length > 0;
  const startTs = hasPoints ? commute.gps_points[0].ts : undefined;
  const endTs = hasPoints ? commute.gps_points[commute.gps_points.length - 1].ts : undefined;

  const startDate = startTs ? new Date(startTs) : new Date(0);
  const endDate = endTs ? new Date(endTs) : new Date(0);

  const duration = Math.max(0, Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60))); // in minutes

  return {
    ...commute,
    duration,
    startDate,
    endDate
  };
};

export const formatDuration = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  
  if (hours > 0) {
    return `${hours}h ${mins}m`;
  }
  return `${mins}m`;
};

export const formatDateTime = (date: Date): string => {
  return date.toLocaleString();
};

export const filterCommutesByTime = (commutes: Commute[], timeFilter: 'today' | 'week' | 'all'): Commute[] => {
  if (timeFilter === 'all') {
    return commutes;
  }

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  if (timeFilter === 'today') {
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    
    return commutes.filter(commute => {
      if (!commute.gps_points || commute.gps_points.length === 0) return false;
      const firstTs = commute.gps_points[0].ts;
      const commuteDate = new Date(firstTs);
      return commuteDate >= today && commuteDate < tomorrow;
    });
  }
  
  if (timeFilter === 'week') {
    const weekAgo = new Date(today);
    weekAgo.setDate(weekAgo.getDate() - 7);
    
    return commutes.filter(commute => {
      if (!commute.gps_points || commute.gps_points.length === 0) return false;
      const firstTs = commute.gps_points[0].ts;
      const commuteDate = new Date(firstTs);
      return commuteDate >= weekAgo && commuteDate <= now;
    });
  }
  
  return commutes;
};
